
import React from "react";

export function VideoLoading() {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-70 text-white">
      <div className="text-center">
        <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-white mb-2"></div>
        <p>Loading video...</p>
      </div>
    </div>
  );
}
